import { WrsClaimer } from '../worsening/WrsClaimer';
import { WrsAdvocate } from '../worsening/WrsAdvocate';
import { FormGroup } from '@angular/forms';
import { UploadEntity } from 'moh-package';

export class WrsWorsening {

  IDIsNotValid: boolean;
  ClaimerDetails: WrsClaimer;
  HasAdvocate: boolean;
  AdvocateDetails: WrsAdvocate;
  WorseDetails: string;
  MedicalDocuments: Array<UploadEntity>;
  FormType: string;

  constructor(formValue: FormGroup) {

    var duplicateObject = JSON.parse(JSON.stringify(formValue));

    Object.assign(this, duplicateObject);

    this.ClaimerDetails = new WrsClaimer(this.ClaimerDetails);

    this.AdvocateDetails = new WrsAdvocate(this.AdvocateDetails);
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/worsening/WrsWorsening.ts